<template>
  <div class="cart-popup__header">
    <span class="cart-popup__header-text">
      눈 건강 자가진단
      <!-- 20201-01-15, 기능없음으로 제거
        <a href="#" data-dismiss="modal" aria-label="Close" aria-hidden="true" class="cart-popup_cc cart-popup__close"><img src="https://www.amway.co.kr/_ui/responsive/theme-blue/images/close.png" alt="새로고침"></a>
      -->
    </span>
  </div>
</template>

<script>
export default {
  name: 'tripleEyeHeader'
}
</script>



// WEBPACK FOOTER //
// src/views/triple-eye-care/component/header.vue